import { createModule, action, mutation } from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { CreateNotificationDto, FindNotificationsDto, NotificationsResponse } from '@/@types/Notification';

const VuexModule = createModule({
  namespaced: 'theoryApiNotificationsStore',
  strict: false,
});

export class NotificationsStore extends VuexModule {
  private readonly notificationsRepository = RepositoryFactory.theoryApi.notificationsRepository();
  /** state */
  private notifications: NotificationsResponse | null = null;
  private unreadNotifications: NotificationsResponse | null = null;

  @mutation
  private setNotifications(payload: NotificationsResponse | null) {
    this.notifications = payload;
  }

  @mutation
  private setUnreadNotifications(payload: NotificationsResponse | null) {
    this.unreadNotifications = payload;
  }

  @action
  async fetchNotifications(params: FindNotificationsDto) {
    const results = await this.notificationsRepository.fetchNotification(params);
    this.setNotifications(results);
  }

  @action
  async fetchUnreadNotifications(params: FindNotificationsDto) {
    const results = await this.notificationsRepository.fetchNotification(params);
    this.setUnreadNotifications(results);
  }

  @action
  async createNotification(params: CreateNotificationDto) {
    await this.notificationsRepository.createNotification(params);
  }

  @action
  async deleteNotifications() {
    this.setNotifications(null);
  }

  @action
  async deleteUnreadNotifications() {
    this.setUnreadNotifications(null);
  }

  /**storeにデータを持つ必要が無いため、取得してアカウント名を返すのみ */
  @action
  async fetchNotificationTargetAccountName(accountId: number) {
    return await this.notificationsRepository.getNotificationTargetAccountName(accountId);
  }

  get getNotifications() {
    return this.notifications;
  }

  get getUnreadNotifications() {
    return this.unreadNotifications;
  }
}
